import { render } from "./CategoryDistributionChart.vue?vue&type=template&id=344a98b1&scoped=true"
import script from "./CategoryDistributionChart.vue?vue&type=script&lang=js"
export * from "./CategoryDistributionChart.vue?vue&type=script&lang=js"

import "./CategoryDistributionChart.vue?vue&type=style&index=0&id=344a98b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-344a98b1"]])

export default __exports__